import { api } from "./configs/axiosConfigs";

export const BulkAPI = {
  sendBulkData: async (payload) => {
    const response = await api.post("/bulk-data", payload);
    return response?.data;
  },
};
